// Core Web Vitals -mittarointi. Käyttää Googlen `web-vitals`-kirjastoa ja
// lähettää tulokset GA4:ään `event`-tapahtumana (standardi nimi, GA4:n
// oma "Web Vitals" -raportti tunnistaa sen suoraan) sekä `console.info`
// -riville dev-tilassa jotta muutosten vaikutuksen näkee heti.
//
// Käytetään client-only useEffectissä (ks. src/components/Layout.tsx),
// jolloin mittarit alkavat vasta hydraation jälkeen ja SSR pysyy puhtaana.
import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";
import { trackEvent } from "@/lib/gtag";

function report(metric: Metric) {
  const value =
    metric.name === "CLS" ? Math.round(metric.value * 1000) : Math.round(metric.value);

  // GA4: standardi "web_vitals" -event. Rating (good/needs-improvement/poor)
  // ja delta talteen jotta trendejä voi seurata Explore-raporteissa.
  // Menee saman evästesuostumuksen portin läpi kuin kaikki muutkin eventit.
  trackEvent("web_vitals", {
    metric_name: metric.name,
    metric_id: metric.id,
    metric_value: value,
    metric_delta: metric.delta,
    metric_rating: metric.rating,
    // GA4:n vakiokentät jotta Realtime + Explore poimivat suoraan
    value,
    event_category: "Web Vitals",
    event_label: metric.id,
    non_interaction: true,
  });

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.info(
      `[web-vitals] ${metric.name} = ${value} (${metric.rating})`,
      metric,
    );
  }
}

let started = false;

/**
 * Rekisteröi kaikki tuetut Core Web Vitals -mittarit. Turvallinen kutsua
 * useasti — käynnistyy vain kerran per sivunlataus.
 */
export function startWebVitals() {
  if (typeof window === "undefined") return;
  if (started) return;
  started = true;

  onLCP(report);
  onCLS(report);
  onINP(report);
  onFCP(report);
  onTTFB(report);
}